import { useEffect } from "react";
import "components/Checkout/checkout.scss";
import CheckoutForms from "components/Checkout/CheckoutForms";

const Checkout = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <div className='checkout-container'>
      <h1 className='page-component-title'>Checkout</h1>
      <hr />
      <CheckoutForms />
    </div>
  );
};

export default Checkout;
